import { render, staticRenderFns } from "./FToggleButton.vue?vue&type=template&id=87a2d91e&"
import script from "./FToggleButton.vue?vue&type=script&lang=js&"
export * from "./FToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports